import { Link } from "react-router-dom";

export const FileDownloadView = ({ url }) => {
  if (!url) return null;

  const getFileName = (url) => {
    if (url == null || url == "") {
      return "";
    }
    console.log(url, "url");

    return url.substring(url.lastIndexOf("/") + 1);
  };

  const fileName = url?.name;

  return (
    <div className="rounded-xl border p-4 shadow-md w-full max-w-[30rem] flex justify-between items-center bg-primary text-white my-4">
      <div className="text-sm font-medium truncate">{fileName}</div>
      <Link
        to={url}
        download={fileName}
        target="_blank"
        className="inline-block bg-lightBg text-primary text-sm px-4 py-2 rounded hover:bg-blue-700"
      >
        Download
      </Link>
    </div>
  );
};

export const MultiFileDownloadView = ({ urls }) => {
  if (!urls) return null;

  const getFileName = (url) => {
    if (url == null || url == "") {
      return "";
    }
    return url.substring(url.lastIndexOf("/") + 1);
  };

  return (
    <>
      {urls?.map((item, index) => (
        <div
          key={index}
          className="rounded-xl border p-4 shadow-md w-full max-w-[30rem] flex justify-between items-center bg-primary text-white my-4"
        >
          <div className="text-sm font-medium truncate">
            {getFileName(item)}
          </div>
          <Link
            to={item}
            download={getFileName(item)}
            target="_blank"
            className="inline-block bg-lightBg text-primary text-sm px-4 py-2 rounded hover:bg-blue-700"
          >
            Download
          </Link>
        </div>
      ))}
    </>
  );
};
